<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Program/POA/components/Bitacora/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>